import React from 'react'
import { MenuItemType } from '@utils/types'
import { EditableDescription } from '@components/atoms'
import styles from './CalendarDateCard.module.sass'
import { insertLineBreakBeforeYear } from '@utils/index'

interface Props {
  item: MenuItemType
  editMode?: boolean
  className?: string
}

const CalendarDateCard = (props: Props) => {
  const { item = undefined, editMode = false, className = '' } = props

  return item ? (
    <div className={`${styles.root} ${editMode ? styles['root--editMode'] : ''} ${className}`}>
      {(!!item.name || !!item.description) && (
        <div className={styles.main}>
          <div className={styles.date}>
            <EditableDescription
              description={item.name}
              className={styles.title}
              editMode={editMode}
            />
          </div>

          <div className={styles.content}>
            <EditableDescription
              description={item.description}
              className={styles.description}
              editMode={editMode}
            />
          </div>
        </div>
      )}
    </div>
  ) : (
    <></>
  )
}

export default CalendarDateCard
